import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login(data: any) {
    return this.http.post(environment.apiUrl + '/auth/login', data);
  }

  // STORE USER DATA
  storeUserData(data: any) {
    sessionStorage.setItem('token', data.access_token);
    sessionStorage.setItem('user', JSON.stringify(data.user));
  }

  // GET TOKEN
  getToken(): string | null {
    return sessionStorage.getItem('token');
  }

  // GET USER
  getUser() {
    const user = sessionStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  // CHECK LOGIN
  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  // CLEAR USER DATA
  clearUserData() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  }

  // LOGOUT
  logout() {
    this.clearUserData();
    this.router.navigate(['/login']);
  }
}